<template lang="pug">
  v-col(sm='12')
    v-row(no-gutters)
      v-col(style='padding: 0 20px')
        md-card
          md-card-header.md-card-header-icon.md-card-header-green
            .card-icon
              md-icon brush
            h4.title
              | {{ $t("webChannel.buttonAnimationSettings.title") }}
          md-card-content
            form.form-horizontal(action method='post')
              .md-layout
                .md-layout-item(style='margin: auto;')
                  | {{
                  | $t(
                  | "webChannel.buttonAnimationSettings.subitems.enableAnimation"
                  | )
                  | }}
                .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto;' :class="{\
                'text-success': canalWebData.buttonAnimation,\
                'text-danger': !canalWebData.buttonAnimation\
                }")
                  | {{
                  | canalWebData.buttonAnimation
                  | ? $t("commonWords.enabled")
                  | : $t("commonWords.disabled")
                  | }}
                .md-layout-item.md-size-15
                  md-switch(v-model='canalWebData.buttonAnimation')
              .md-layout(v-if='canalWebData.buttonAnimation')
                .md-layout-item.md-size-100
                  md-field(style='margin-top: 30px')
                    label
                      | {{
                      | $t(
                      | "webChannel.buttonAnimationSettings.subitems.animationDevice"
                      | )
                      | }}
                    md-select(v-model='device')
                      span(v-for='(label, i) in animationDevice' :key='i')
                        md-option(:value='label.code') {{ label.displayName }}
              .md-layout(v-if='canalWebData.buttonAnimation')
                .md-layout-item.md-size-100
                  md-field(style='margin-top: 30px')
                    label
                      | {{
                      | $t(
                      | "webChannel.buttonAnimationSettings.subitems.animationType"
                      | )
                      | }}
                    md-select(v-model='canalWebData[device].buttonAnimationType')
                      span(v-for='(label, i) in animationType' :key='i')
                        md-option(:value='label.code') {{ label.displayName }}
                  md-field(style='margin-top: 30px')
                    label
                      | {{
                      | $t(
                      | "webChannel.buttonAnimationSettings.subitems.animationText"
                      | )
                      | }}
                    md-input(v-model='canalWebData[device].buttonAnimationText')
              .md-layout(v-if='canalWebData.buttonAnimation' style='margin: auto')
                .md-layout-item.md-form-label.md-size-25
                  | {{
                  | $t(
                  | "webChannel.buttonAnimationSettings.subitems.animationInitTime"
                  | )
                  | }}
                .md-layout-item.md-size-15
                  md-field(style='display: flex')
                    md-input(v-model='canalWebData[device].buttonAnimationInitTime')
                .md-layout-item.md-form-label.md-size-5
                  | {{
                  | $t(
                  | "webChannel.buttonAnimationSettings.subitems.seconds"
                  | )
                  | }}
              .md-layout(v-if='canalWebData.buttonAnimation && canalWebData[device].buttonAnimationType !== "slide"')
                .md-layout-item(style='margin: auto;')
                  | {{
                  | $t(
                  | "webChannel.buttonAnimationSettings.subitems.animationRepetition"
                  | )
                  | }}
                .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto;' :class="{\
                'text-success': canalWebData[device].buttonAnimationRepetitionEnable,\
                'text-danger': !canalWebData[device].buttonAnimationRepetitionEnable\
                }")
                  | {{
                  | canalWebData[device].buttonAnimationRepetitionEnable
                  | ? $t("commonWords.enabled")
                  | : $t("commonWords.disabled")
                  | }}
                .md-layout-item.md-size-15
                  md-switch(v-model='canalWebData[device].buttonAnimationRepetitionEnable')
              .md-layout(v-if='canalWebData.buttonAnimation && canalWebData[device].buttonAnimationType !== "slide" && canalWebData[device].buttonAnimationRepetitionEnable' style='margin: auto')
                .md-layout-item.md-form-label.md-size-20
                  | {{
                  | $t(
                  | "webChannel.buttonAnimationSettings.subitems.animationDuration"
                  | )
                  | }}
                .md-layout-item.md-size-15
                  md-field(style='display: flex')
                    md-input(v-model='canalWebData[device].buttonAnimationRepetitionInterval')
                .md-layout-item.md-form-label.md-size-5
                  | {{
                  | $t(
                  | "webChannel.buttonAnimationSettings.subitems.seconds"
                  | )
                  | }}
</template>

<script>
export default {
  props: {
    canalWebData: {
      type: Object,
      required: true
    }
  },
  created () {
    if (typeof this.canalWebData['desktop'] === 'undefined') {
      this.canalWebData['desktop'] = {}
    }
    if (typeof this.canalWebData['mobile'] === 'undefined') {
      this.canalWebData['mobile'] = {}
    }
  },
  data () {
    return {
      device: 'desktop',
      animationRepetition: true,
      animationType: [
        {
          displayName: this.$t('webChannel.buttonAnimationSettings.subitems.blink'),
          code: 'blink'
        },
        {
          displayName: this.$t('webChannel.buttonAnimationSettings.subitems.shake'),
          code: 'shake'
        },
        {
          displayName: this.$t('webChannel.buttonAnimationSettings.subitems.slide'),
          code: 'slide'
        }
      ],
      animationDevice: [
        {
          displayName: this.$t('webChannel.buttonAnimationSettings.subitems.desktop'),
          code: 'desktop'
        },
        {
          displayName: this.$t('webChannel.buttonAnimationSettings.subitems.mobile'),
          code: 'mobile'
        }
        // {
        //   displayName: this.$t('webChannel.buttonAnimationSettings.subitems.both'),
        //   code: 'both'
        // }
      ]
    }
  }
}
</script>
